module.exports = __webpack_public_path__ + "img/employee-time-tracking.c2c0c941.svg";